export default "__VITE_ASSET__DTaZdCov__"